import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from '../ui/modal-dialog';
import Form from '../ui/form';
import MultipleSelector from '../ui/multiple-selector'; // api

import { getUserList } from '../../api/userAPI';
import { getTerminalAccounts, setTerminalRelatedCameraAPI, getLogisticAccounts, setLogisticRelatedCameraAPI } from '../../api/relatedAPI';
var gt = i18n.getFixedT(null, 'app');

var RelatedEditor = function RelatedEditor(props) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      formData = _useState4[0],
      setFormData = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      userList = _useState6[0],
      setUserList = _useState6[1];

  var contextRoot = props.contextRoot,
      type = props.type,
      onClose = props.onClose,
      _props$editData = props.editData,
      name = _props$editData.name,
      id = _props$editData.id;
  var isMounted = useRef(false);

  var handleSelectorChange = function handleSelectorChange(dataList) {
    var list = dataList.map(function (el) {
      return el.value;
    });
    setFormData(list);
  };

  var handleClose = function handleClose() {
    onClose();
  };

  var handleConfirm = function handleConfirm() {
    if (_.isEmpty(formData)) return onClose();
    var setAPI = type === 'terminals' ? setTerminalRelatedCameraAPI : setLogisticRelatedCameraAPI;
    setAPI(contextRoot, false, id, formData).then(function (result) {
      onClose();
    });
  };

  useEffect(function () {
    var userSort = {
      field: 'username',
      desc: false
    };
    getUserList(contextRoot, true, null, userSort).then(function (result) {
      var list = _.map(result.content, function (el) {
        return {
          value: el.id,
          text: el.username + '-' + el.name
        };
      });

      setUserList(list);
      var getAPI = type === 'terminals' ? getTerminalAccounts : getLogisticAccounts;
      return getAPI(contextRoot, true, id);
    }).then(function (result) {
      setData(result.content);
      isMounted.current = true;
    });
  }, []);
  var fields = {};

  _.set(fields, 'name', {
    label: type === 'terminals' ? gt('system.terminals') : gt('system.logistics'),
    formatter: function formatter(val, row) {
      return name;
    }
  });

  _.set(fields, 'accounts', {
    label: gt('system.related-users'),
    formatter: function formatter(val, row) {
      var values = _.map(row, function (el) {
        return {
          value: el.id,
          text: el.username + '-' + el.name
        };
      });

      return /*#__PURE__*/React.createElement(MultipleSelector, {
        width: '430px',
        options: userList,
        onChange: handleSelectorChange,
        value: values
      });
    }
  });

  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-answer-cancel'),
    handler: handleClose
  });

  _.set(actions, 'confirm', {
    text: gt('global.lbl-answer-ok'),
    className: 'button-success',
    handler: handleConfirm
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: 'editor-related-user',
    title: name + ' - ' + gt('system.related-users'),
    global: true,
    actions: actions,
    closeAction: "cancel"
  }, data === null ? /*#__PURE__*/React.createElement("div", {
    className: "loading"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-circle-notch fa-spin fa-3x fa-fw"
  })) : /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form"),
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    value: _.isEmpty(data) ? {} : data
  }));
};

export default RelatedEditor;